const BACKEND_FAILURE_EVENT = "phmis:backend-failure";
const BACKEND_RECOVERY_EVENT = "phmis:backend-recovery";

type FailureDetail = {
  status?: number;
  message?: string;
};

let backendUnavailable = false;

export const isBackendHealthy = () => !backendUnavailable;

const dispatchEvent = (name: string, detail?: FailureDetail) => {
  if (typeof window === "undefined") {
    return;
  }
  const event =
    detail !== undefined
      ? new CustomEvent<FailureDetail>(name, { detail })
      : new Event(name);
  window.dispatchEvent(event);
};

export const reportBackendFailure = (detail?: FailureDetail) => {
  if (backendUnavailable) {
    return;
  }
  backendUnavailable = true;
  dispatchEvent(BACKEND_FAILURE_EVENT, detail);
};

export const reportBackendHealthy = () => {
  if (!backendUnavailable) {
    return;
  }
  backendUnavailable = false;
  dispatchEvent(BACKEND_RECOVERY_EVENT);
};

export { BACKEND_FAILURE_EVENT, BACKEND_RECOVERY_EVENT };
